var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "min-height": "600px"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [!_vm.isMobile ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "subtitle-1 font-weight-bold mb-2 mr-4"
  }, [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.vehicle")) + " ")]), _c('v-card', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_vm.selectedVehicle ? _c('refs-vehicle', {
    attrs: {
      "item": _vm.selectedVehicle
    },
    on: {
      "openDetail": _vm.goToVehicle
    }
  }) : _c('v-card-text', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.noVehicleSelected")))])], 1)], 1), _vm.selectedVehicle ? _c('v-card', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "outlined": ""
    }
  }, [!_vm.selectedVehicle.groupId ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "error"
    }
  }, [_vm._v("mdi-alert-circle")])], 1), _c('v-col', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.vehicleNotAssigned")) + " "), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.assignFleet")))])])], 1)], 1) : _vm.isLoadingFleet ? _c('v-card-text', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar"
    }
  })], 1) : _vm.selectedFleet ? _c('div', [_c('refs-fleet', {
    attrs: {
      "item": _vm.selectedFleet
    },
    on: {
      "openDetail": _vm.goToFleet
    },
    scopedSlots: _vm._u([{
      key: "titleActions",
      fn: function fn() {
        return [_vm.selectedFleet.description ? _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              _vm.isFleetDescriptionExpanded = !_vm.isFleetDescriptionExpanded;
            }
          }
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.isFleetDescriptionExpanded ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 1015852348)
  }), _c('transition', {
    attrs: {
      "name": "expand"
    }
  }, [_vm.isFleetDescriptionExpanded && _vm.selectedFleet && _vm.selectedFleet.description ? _c('v-card-text', {
    staticClass: "refs-fleet-description",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedFleet.description)
    }
  }) : _vm._e()], 1)], 1) : _c('v-card-text', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.noFleetContext")))])], 1) : _vm._e(), _vm.selectedFleet && _vm.selectedFleet.company ? _c('v-card', {
    staticClass: "mx-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('company-sheet', {
    attrs: {
      "color": "white",
      "company": _vm.selectedFleet.company
    }
  })], 1) : _vm._e(), _vm.canReadPerson ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "subtitle-1 font-weight-bold mb-2 mr-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.driver")) + " ")]), _c('v-card', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_vm.selectedPerson ? _c('refs-person', {
    attrs: {
      "item": _vm.selectedPerson
    }
  }) : _c('v-card-text', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.noDriverSelected")))])], 1)], 1) : _vm._e(), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "subtitle-1 font-weight-bold mb-2 mr-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.damage")) + " ")]), _c('v-card', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "outlined": ""
    }
  }, [_vm.damageType && _vm.coverageType ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm.drivable ? _c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.drivable.color
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.drivable.label)) + " ")]) : _vm._e()], 1), _c('v-list-item-subtitle', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-hammer-wrench")]), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.$t("enums.DamageTypeEnum.".concat(_vm.damageType))))]), _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-shield-outline")]), _c('span', [_vm._v(_vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(_vm.coverageType))))])], 1)], 1)], 1) : _c('v-card-text', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.noDamageInfo")))])], 1)], 1)], 1) : _vm._e(), _c('v-col', {
    staticClass: "d-flex flex-column left-border-column",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "flex-grow-1 d-flex flex-column",
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper', {
    staticClass: "elevation-0 flex-grow-0",
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepCompletion.step1,
      "step": _vm.CreateReportSteps.VEHICLE,
      "editable": "",
      "complete-icon": "mdi-check"
    },
    on: {
      "click": function click($event) {
        return _vm.setStep(_vm.CreateReportSteps.VEHICLE);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.vehicle")) + " "), _vm.stepCompletion.step1 ? _c('small', [_vm._v(" " + _vm._s(_vm.selectedVehicle ? _vm.selectedVehicle.numberplate : _vm.numberplate) + " ")]) : _vm._e()]), _c('v-divider'), _vm.canReadPerson ? _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepCompletion.step2,
      "step": _vm.CreateReportSteps.DRIVER,
      "editable": "",
      "complete-icon": "mdi-check"
    },
    on: {
      "click": function click($event) {
        return _vm.setStep(_vm.CreateReportSteps.DRIVER);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.driver")) + " "), _vm.stepCompletion.step2 ? _c('small', [_vm._v(" " + _vm._s(_vm.selectedPerson ? "".concat(_vm.selectedPerson.firstName, " ").concat(_vm.selectedPerson.lastName) : "") + " ")]) : _vm._e()]) : _vm._e(), _vm.canReadPerson ? _c('v-divider') : _vm._e(), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepCompletion.step3,
      "step": _vm.CreateReportSteps.DAMAGE,
      "editable": "",
      "complete-icon": "mdi-check"
    },
    on: {
      "click": function click($event) {
        return _vm.setStep(_vm.CreateReportSteps.DAMAGE);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.damage")) + " "), _vm.stepCompletion.step3 && _vm.damageType ? _c('small', [_vm._v(" " + _vm._s(_vm.$t("enums.DamageTypeEnum.".concat(_vm.damageType))) + " ")]) : _vm._e()]), _c('v-divider'), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.stepCompletion.step4,
      "step": _vm.CreateReportSteps.CONFIRM,
      "editable": "",
      "complete-icon": "mdi-check"
    },
    on: {
      "click": function click($event) {
        return _vm.setStep(_vm.CreateReportSteps.CONFIRM);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1), _c('v-stepper-items', {
    staticClass: "flex-grow-1"
  }, [_c('v-stepper-content', {
    attrs: {
      "step": _vm.CreateReportSteps.VEHICLE
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.vehicleSearch")) + " ")]), _c('v-spacer'), _vm.canCreateVehicle ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.isCreateVehicleDialogActive = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.newVehicle")))]) : _vm._e(), _vm.canCreateVehicle ? _c('create-vehicle-dialog', {
    attrs: {
      "isDialogActive": _vm.isCreateVehicleDialogActive,
      "partnerId": _vm.partnerId,
      "isAutoClose": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreateVehicleDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreateVehicleDialogActive = $event;
      },
      "vehicleCreated": _vm.setVehicle
    }
  }) : _vm._e()], 1), _c('v-card-text', [_c('v-autocomplete', {
    ref: "vehicleSearchAutocomplete",
    attrs: {
      "focus": "",
      "items": _vm.filteredVehicles,
      "loading": _vm.isSearchingVehicles,
      "search-input": _vm.vehicleSearchPattern,
      "item-text": "numberplate",
      "item-value": "id",
      "label": _vm.$t('components.partner.PartnerReportCreateForm.vehicle'),
      "placeholder": _vm.$t('components.partner.PartnerReportCreateForm.vehiclePlaceholder'),
      "color": _vm.selectedVehicle ? 'success' : '',
      "return-object": "",
      "clearable": "",
      "outlined": "",
      "autofocus": "",
      "hint": _vm.$t('components.partner.PartnerReportCreateForm.vehicleSearchHint'),
      "persistent-hint": "",
      "no-filter": true
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.vehicleSearchPattern = $event;
      },
      "update:search-input": [function ($event) {
        _vm.vehicleSearchPattern = $event;
      }, _vm.debounceVehicleSearch],
      "input": _vm.checkStep1Completion,
      "change": _vm.checkStep1Completion,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterVehicleSearch.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm.isSearchingVehicles ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.searchingVehicles")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.vehicleSearchPattern && _vm.vehicleSearchPattern.length >= 2 ? _vm.$t("components.partner.PartnerReportCreateForm.noVehiclesFound") : _vm.$t("components.partner.PartnerReportCreateForm.searchForVehicle")) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('refs-vehicle', {
          attrs: {
            "item": item
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function fn() {
              return [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-car")])], 1)];
            },
            proxy: true
          }], null, true)
        })];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm.selectedVehicle ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e(), _c('span', {
          staticClass: "pr-2 grey--text text--darken-1"
        }, [_vm._v(_vm._s(item.displayName || item.numberplate))])];
      }
    }]),
    model: {
      value: _vm.selectedVehicle,
      callback: function callback($$v) {
        _vm.selectedVehicle = $$v;
      },
      expression: "selectedVehicle"
    }
  })], 1)], 1), _vm.selectedFleet && _vm.selectedFleet.description ? _c('v-card', {
    staticClass: "ma-4",
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "auto"
    },
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('refs-fleet', {
    attrs: {
      "item": _vm.selectedFleet
    },
    on: {
      "openDetail": _vm.goToFleet
    }
  }), _c('v-card-text', {
    staticClass: "refs-fleet-description",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedFleet.description)
    }
  })], 1) : _vm._e()], 1), _vm.canReadPerson ? _c('v-stepper-content', {
    attrs: {
      "step": _vm.CreateReportSteps.DRIVER
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.driverSearch")) + " ")]), _c('v-spacer'), _vm.canCreatePerson ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.isCreatePersonDialogActive = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.newPerson")))]) : _vm._e(), _vm.canCreatePerson ? _c('person-create-dialog', {
    attrs: {
      "isDialogActive": _vm.isCreatePersonDialogActive,
      "partnerId": _vm.partnerId,
      "hideButton": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreatePersonDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreatePersonDialogActive = $event;
      },
      "created": _vm.setPerson
    }
  }) : _vm._e()], 1), _c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isDriverValid,
      callback: function callback($$v) {
        _vm.isDriverValid = $$v;
      },
      expression: "isDriverValid"
    }
  }, [_c('v-autocomplete', {
    ref: "vehiclePersonAutocomplete",
    attrs: {
      "items": _vm.filteredPersons,
      "loading": _vm.isSearchingPersons,
      "autofocus": "",
      "search-input": _vm.personSearchPattern,
      "item-text": "titleReadable",
      "item-value": "id",
      "label": _vm.$t('components.partner.PartnerReportCreateForm.driver'),
      "placeholder": _vm.$t('components.partner.PartnerReportCreateForm.driverPlaceholder'),
      "color": _vm.selectedPerson ? 'success' : '',
      "return-object": "",
      "clearable": "",
      "outlined": "",
      "hint": _vm.$t('components.partner.PartnerReportCreateForm.driverSearchHint'),
      "persistent-hint": "",
      "no-filter": true
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.personSearchPattern = $event;
      },
      "update:search-input": [function ($event) {
        _vm.personSearchPattern = $event;
      }, _vm.debouncePersonSearch],
      "input": _vm.checkStep2Completion,
      "change": _vm.checkStep2Completion
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm.isSearchingPersons ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.searchingPersons")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.personSearchPattern && _vm.personSearchPattern.length >= 2 ? _vm.$t("components.partner.PartnerReportCreateForm.noPersonsFound") : _vm.$t("components.partner.PartnerReportCreateForm.searchForPerson")) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('refs-person', {
          attrs: {
            "item": item
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function fn() {
              return [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-account")])], 1)];
            },
            proxy: true
          }], null, true)
        })];
      }
    }, {
      key: "selection",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.selectedPerson ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e(), _c('span', {
          staticClass: "pr-2"
        }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])];
      }
    }], null, false, 261750294),
    model: {
      value: _vm.selectedPerson,
      callback: function callback($$v) {
        _vm.selectedPerson = $$v;
      },
      expression: "selectedPerson"
    }
  }), _vm.selectedPerson ? _c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "items": _vm.selectedPerson.emails,
      "item-text": "email",
      "label": _vm.$t('common.nouns.email'),
      "rules": _vm.requiredRule,
      "search-input": _vm.mailSearch,
      "loading": _vm.isMailEditLoading,
      "disabled": _vm.isMailEditLoading,
      "return-object": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.mailSearch = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.mailSearch = $event;
      }
    },
    nativeOn: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onMailEnter.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref5) {
        var item = _ref5.item,
            attrs = _ref5.attrs,
            on = _ref5.on;
        return [_c('v-list-item', _vm._g(_vm._b({}, 'v-list-item', attrs, false), on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.email))])], 1), _vm.canUpdatePerson ? _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.startUpdateEmail(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-pencil")])], 1)], 1) : _vm._e()], 1)];
      }
    }, _vm.canUpdatePerson ? {
      key: "no-data",
      fn: function fn() {
        return [_c('v-list-item', {
          on: {
            "click": _vm.startCreateEmail
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-plus")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PersonEmailDialog.title")) + " ")])], 1)], 1)];
      },
      proxy: true
    } : null, {
      key: "selection",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [item ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e(), item.email ? _c('span', {
          staticClass: "pr-2"
        }, [_vm._v(_vm._s(item.email))]) : _vm._e()];
      }
    }], null, true),
    model: {
      value: _vm.mail,
      callback: function callback($$v) {
        _vm.mail = $$v;
      },
      expression: "mail"
    }
  }) : _vm._e(), _c('person-email-dialog', {
    attrs: {
      "isDialogActive": _vm.isCreateMailDialogActive
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreateMailDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreateMailDialogActive = $event;
      },
      "save": _vm.addEmail
    },
    model: {
      value: _vm.mailToEdit,
      callback: function callback($$v) {
        _vm.mailToEdit = $$v;
      },
      expression: "mailToEdit"
    }
  }), _c('person-email-dialog', {
    attrs: {
      "isDialogActive": _vm.isUpdateMailDialogActive,
      "title": "update"
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isUpdateMailDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isUpdateMailDialogActive = $event;
      },
      "save": _vm.updateEmail
    },
    model: {
      value: _vm.mailToEdit,
      callback: function callback($$v) {
        _vm.mailToEdit = $$v;
      },
      expression: "mailToEdit"
    }
  }), _vm.selectedPerson ? _c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "items": _vm.selectedPerson.phones,
      "item-text": "phone",
      "label": _vm.$t('common.nouns.phone'),
      "search-input": _vm.phoneSearch,
      "loading": _vm.isPhoneEditLoading,
      "disabled": _vm.isPhoneEditLoading,
      "return-object": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.phoneSearch = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.phoneSearch = $event;
      }
    },
    nativeOn: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onPhoneEnter.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref7) {
        var item = _ref7.item,
            attrs = _ref7.attrs,
            on = _ref7.on;
        return [_c('v-list-item', _vm._g(_vm._b({}, 'v-list-item', attrs, false), on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.phone))])], 1), _vm.canUpdatePerson ? _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.startUpdatePhone(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-pencil")])], 1)], 1) : _vm._e()], 1)];
      }
    }, _vm.canUpdatePerson ? {
      key: "no-data",
      fn: function fn() {
        return [_c('v-list-item', {
          on: {
            "click": _vm.startCreatePhone
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-plus")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PersonPhoneDialog.title")) + " ")])], 1)], 1)];
      },
      proxy: true
    } : null, {
      key: "selection",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [item ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e(), item.phone ? _c('span', {
          staticClass: "pr-2"
        }, [_vm._v(_vm._s(item.phone))]) : _vm._e()];
      }
    }], null, true),
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  }) : _vm._e(), _c('person-phone-dialog', {
    attrs: {
      "isDialogActive": _vm.isCreatePhoneDialogActive
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCreatePhoneDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCreatePhoneDialogActive = $event;
      },
      "save": _vm.addPhone
    },
    model: {
      value: _vm.phoneToEdit,
      callback: function callback($$v) {
        _vm.phoneToEdit = $$v;
      },
      expression: "phoneToEdit"
    }
  }), _c('person-phone-dialog', {
    attrs: {
      "isDialogActive": _vm.isUpdatePhoneDialogActive,
      "title": "update"
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isUpdatePhoneDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isUpdatePhoneDialogActive = $event;
      },
      "save": _vm.updatePhone
    },
    model: {
      value: _vm.phoneToEdit,
      callback: function callback($$v) {
        _vm.phoneToEdit = $$v;
      },
      expression: "phoneToEdit"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c('v-stepper-content', {
    attrs: {
      "step": _vm.CreateReportSteps.DAMAGE
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.damage")))]), _c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isDamageValid,
      callback: function callback($$v) {
        _vm.isDamageValid = $$v;
      },
      expression: "isDamageValid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isDrivable')
      }
    },
    model: {
      value: _vm.isDrivable,
      callback: function callback($$v) {
        _vm.isDrivable = $$v;
      },
      expression: "isDrivable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isRoadworthy')
      }
    },
    model: {
      value: _vm.isRoadworthy,
      callback: function callback($$v) {
        _vm.isRoadworthy = $$v;
      },
      expression: "isRoadworthy"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.damageTypeItems,
      "label": _vm.$t('components.partner.PartnerReportCreateForm.damageTypeLabel'),
      "outlined": "",
      "autofocus": "",
      "filter": _vm.customFilter,
      "item-text": "text",
      "item-value": "value",
      "return-object": false,
      "rules": _vm.requiredRule,
      "clearable": ""
    },
    on: {
      "change": _vm.checkStep3Completion
    },
    model: {
      value: _vm.damageType,
      callback: function callback($$v) {
        _vm.damageType = $$v;
      },
      expression: "damageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.coverageTypeItems,
      "label": _vm.$t('components.partner.PartnerReportCreateForm.coverageTypeLabel'),
      "outlined": "",
      "filter": _vm.customFilter,
      "item-text": "text",
      "item-value": "value",
      "return-object": false,
      "rules": _vm.requiredRule,
      "clearable": ""
    },
    on: {
      "change": _vm.checkStep3Completion
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.text) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_vm._v(" " + _vm._s(item.text) + " ")];
      }
    }]),
    model: {
      value: _vm.coverageType,
      callback: function callback($$v) {
        _vm.coverageType = $$v;
      },
      expression: "coverageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('common.nouns.description'),
      "flat": "",
      "outlined": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": _vm.CreateReportSteps.CONFIRM
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.nextSteps")))]), _c('v-card-subtitle', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerReportCreateForm.checkSummaryBeforeCreation")))]), _vm.canReadPerson ? _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportCreateForm.notifyUserByEmail')
    },
    model: {
      value: _vm.isNotifyUser,
      callback: function callback($$v) {
        _vm.isNotifyUser = $$v;
      },
      expression: "isNotifyUser"
    }
  }), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportCreateForm.shareWithDriver')
    },
    model: {
      value: _vm.isShared,
      callback: function callback($$v) {
        _vm.isShared = $$v;
      },
      expression: "isShared"
    }
  }), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportCreateForm.requestDamageDocumentation')
    },
    model: {
      value: _vm.isAttachmentRequest,
      callback: function callback($$v) {
        _vm.isAttachmentRequest = $$v;
      },
      expression: "isAttachmentRequest"
    }
  }), _vm.isAttachmentRequest ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.selectableScreens,
      "label": _vm.$t('components.partner.PartnerReportCreateForm.damageDocumentation'),
      "multiple": "",
      "chips": "",
      "hint": _vm.$t('components.partner.PartnerReportCreateForm.whatShouldDriverSubmit'),
      "persistent-hint": "",
      "clearable": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref11) {
        var attrs = _ref11.attrs,
            item = _ref11.item,
            selected = _ref11.selected;
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "close": ""
          },
          on: {
            "click:close": function clickClose($event) {
              return _vm.removeScreen(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v(" " + _vm._s(_vm.$t("screenEnum.".concat(item, ".title"))) + " ")])];
      }
    }], null, false, 1251121568),
    model: {
      value: _vm.screens,
      callback: function callback($$v) {
        _vm.screens = $$v;
      },
      expression: "screens"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-auto pa-4"
  }, [_c('v-spacer'), _vm.currentStep > 1 ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v(" " + _vm._s(_vm.currentStep > 1 ? _vm.$t("back") : _vm.$t("cancel")) + " ")]) : _vm._e(), _vm.currentStep < 4 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.canProceedToNextStep,
      "elevation": "0"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("next")) + " ")]) : _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.loading,
      "elevation": "0"
    },
    on: {
      "click": _vm.submitReport
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportCreateForm.createDamageReport")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }